import { useBitrix } from '@context/useBitrixUser/useBitrix';
import { styled } from '@mui/material';
import * as React from 'react';
import { PropsWithChildren } from 'react';

interface GTagWrapperProps {
  target: string;
  noAuthTarget?: string;
}

const InterceptWrapper = styled('div')`
  position: relative;
`;

/*
Обертка по обработке google analytics
 */
export const GTagWrapper: React.FC<PropsWithChildren<GTagWrapperProps>> = ({
  children,
  target,
  noAuthTarget,
}) => {
  const [{ bitrixUser }] = useBitrix().useBitrixUser().useState(['bitrixUser']);

  const isNoAuthTarget = !bitrixUser && noAuthTarget;

  const clickHandler = () => {
    const goalName = isNoAuthTarget ? noAuthTarget : target;

    const gtag = (window as any).gtag;
    if (typeof gtag !== 'function') {
      console.warn('gtag not ready — event not sent:', goalName);
      return;
    }

    gtag('event', goalName);
  };

  return <InterceptWrapper onClickCapture={clickHandler}>{children}</InterceptWrapper>;
};
